import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: '¿Sirve si recién arranco o si ya tengo clientas?',
  a: 'Es el mejor momento para arrancar con estructura. Si recién empezás, construís bien desde el día uno. Si ya tenés clientas, ordenás, escalás y dejás de perder dinero por errores evitables.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Apenas confirmás el pago recibís el acceso de forma inmediata. Todo en PDF, listo para abrir desde el celular, tablet o computadora. Sin esperas, sin turnos, sin programas raros.'
}, {
  q: '¿Es realmente para el mercado argentino?',
  a: 'Totalmente. Está diseñado pensando en nuestra economía, nuestra inflación, nuestra forma de hablar por WhatsApp y cómo manejar aumentos de insumos sin perder clientas.'
}, {
  q: '¿Tengo que usar Instagram y Meta sí o sí para que funcione?',
  a: 'No. El sistema funciona aunque no tengas Instagram. Los tomos de agenda, WhatsApp y anti-cancelaciones se aplican desde el día uno sin necesidad de redes sociales.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días sin preguntas. Si abrís los tomos y en la primera semana sentís que no vale lo que pagaste, pedís el reembolso y te lo devolvemos el 100%. Sin formularios, sin drama.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Preguntas frecuentes" className="bg-ink" data-id="element-51" data-mp="1fmsqecm8v7n7">
      <div className="mx-auto max-w-3xl px-5 py-20 pt-[0px] pb-[0px]" data-id="element-52" data-mp="11w7h9fmlec2i">
        <h2 className="text-center font-display text-3xl font-black text-white sm:text-4xl" data-id="element-53" data-mp="16np7b8n2us8p">
          ¿ Lo que más nos preguntan ?
        </h2>
        <div className="mt-10 divide-y divide-white/10 overflow-hidden rounded-2xl border border-white/10 bg-ink-2" data-id="element-54" data-mp="s0dyheia5mca">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-55" data-mp="izfq6k0t6snw" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors hover:bg-white/[0.03] pt-[0px] pb-[10px]" data-id="element-56" data-mp="iz677ge6llrp">
                  <span className="text-sm font-bold text-white sm:text-base pt-[3px]" data-id="element-57" data-mp="2kvwvy9cxvb0p">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-rose" data-id="element-58" data-mp="2fwka9rxt09zp" /> : <PlusIcon className="h-5 w-5 shrink-0 text-rose-soft" data-id="element-59" data-mp="2fx3i2ftqpi00" />}
                </button>
                <div className="grid transition-all duration-300 ease-in-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-60" data-mp="2azk4zj8s3b9n">
                  <div className="overflow-hidden" data-id="element-61" data-mp="33lwlsyglsu56">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-white/65" data-id="element-62" data-mp="33kboj12wmx3m">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}